// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class MessageType {
  public static SUCCESS = 1;
  public static ERROR = 2;
  public static INFO = 3;
}

export class Message {
  public displayMessage = false;

  public message = '';

  public messageType = MessageType.INFO;

  constructor(messageType?: number, message?: string) {
    this.messageType = messageType;
    this.message = message;
  }
}

@Injectable()
export class MessageService {
  public _message: Message;

  public messageChange: BehaviorSubject<Message> = new BehaviorSubject<Message>(new Message());

  public timer = null;

  constructor() { }

  emitMessage(message: Message) {
    message.displayMessage = true;
    this._message = message;
    this.messageChange.next(message);

    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.hideMessage();
    }, 15000);
  }

  emitSuccessMessage(messageText: string) {
    const message = new Message();
    message.messageType = MessageType.SUCCESS;
    message.message = messageText;
    this.emitMessage(message);
  }

  emitErrorMessage(messageText: string) {
    const message = new Message();
    message.messageType = MessageType.ERROR;
    message.message = messageText;
    this.emitMessage(message);
  }

  hideMessage() {
    if (this._message) {
      this._message.displayMessage = false;
      this.messageChange.next(this._message);
    }
  }
}
